import React from 'react';

import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    width: '80%',
    maxHeight: 435,
  },
}));

const ConfirmationDialog = (props: any) => {
  const classes = useStyles();
  const {
    onOk = () => {},
    isOpen = false,
    setIsOpen = () => {},
    numberFindingsToValidate = 0,
  } = props;

  const onCancel = () => {
    // TODO: This Confirmation Dialog is currently disabled, but we may want to leverage the reason param for onCancel
    // That's described at https://mui.com/api/dialog/ where we can check which scenarios do we want to close this
    // We can explore that if this dialog is brought back to usage
    setIsOpen(false);
  };

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      open={isOpen}
      keepMounted
      onClose={onCancel}
      classes={{
        paper: classes.paper,
      }}
    >
      <DialogContent dividers>
        {numberFindingsToValidate} finding
        {numberFindingsToValidate > 1 ? 's have not' : ' has not'} been marked
        as Agree/Disagree/Watch, which helps the AI to improve. Are you sure you
        want to continue?
      </DialogContent>

      <DialogActions>
        <Button autoFocus onClick={onCancel} color="primary">
          No, let me check
        </Button>
        <Button onClick={onOk} color="secondary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  numberFindingsToValidate: PropTypes.number,
  isOpen: PropTypes.bool,
  onOk: PropTypes.func,
  setIsOpen: PropTypes.func,
};

export default ConfirmationDialog;
